import { Column } from "@faire/web--source/slate/Layout";
import styled from "styled-components";

export const HeaderAnimationContainer = styled(Column)`
  opacity: 0;
  animation: fadeIn 0.3s ease forwards;
  animation-delay: 0.3s;

  @keyframes fadeIn {
    to {
      opacity: 1;
    }
  }
`;
